import type { StorageCondition } from './storage-condition.enum';

export function isStorageTemperatureComplete(
  condition: StorageCondition | null | undefined,
  minC: number | null | undefined,
  maxC: number | null | undefined,
): boolean {
  if (!condition) {
    return false;
  }
  const min = typeof minC === 'number' && Number.isFinite(minC) ? minC : null;
  const max = typeof maxC === 'number' && Number.isFinite(maxC) ? maxC : null;
  if (condition === 'AMBIENT') {
    return true;
  }
  if (condition === 'CHILLED') {
    return min !== null && max !== null && min <= max;
  }
  if (condition === 'FROZEN') {
    return max !== null && max <= 0;
  }
  return min !== null && min >= 0;
}
